import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { TaskCard, Task, TaskStatus } from '../components/TaskCard';
import { ArrowLeft, Plus, CheckCircle2, Clock, ListTodo, Filter } from 'lucide-react';
// Mock Data
const mockTasks: Task[] = [{
  id: '1',
  title: 'Review Nike campaign deliverables',
  description: 'Check all submitted content for Nike Summer Campaign and provide feedback',
  status: 'in_progress',
  priority: 'high',
  assignee: {
    id: '1',
    name: 'Sarah Klein',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800'
  },
  project: {
    id: '1',
    name: 'Nike Summer Campaign'
  },
  deadline: '2024-06-12',
  commentsCount: 3,
  createdAt: '2024-06-01'
}, {
  id: '2',
  title: 'Prepare media kit for Adidas',
  description: 'Compile performance metrics and create presentation for Adidas partnership',
  status: 'todo',
  priority: 'medium',
  assignee: {
    id: '2',
    name: 'Lisa Schmidt',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800'
  },
  project: {
    id: '2',
    name: 'Adidas Fitness Series'
  },
  deadline: '2024-06-20',
  commentsCount: 0,
  createdAt: '2024-06-05'
}, {
  id: '3',
  title: 'Schedule Red Bull event coverage',
  description: 'Coordinate with Tom for event dates and content requirements',
  status: 'todo',
  priority: 'high',
  assignee: {
    id: '3',
    name: 'Tom Weber',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800'
  },
  project: {
    id: '3',
    name: 'Red Bull Event Coverage'
  },
  deadline: '2024-06-15',
  commentsCount: 1,
  createdAt: '2024-06-03'
}, {
  id: '4',
  title: 'Update creator contracts',
  description: 'Review and update standard creator agreement templates',
  status: 'in_progress',
  priority: 'low',
  assignee: {
    id: '1',
    name: 'Sarah Klein',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800'
  },
  deadline: '2024-06-25',
  commentsCount: 2,
  createdAt: '2024-06-02'
}, {
  id: '5',
  title: 'Analyze Q2 performance metrics',
  description: 'Generate comprehensive report on all campaigns from Q2',
  status: 'done',
  priority: 'medium',
  assignee: {
    id: '4',
    name: 'Felix Meyer',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800'
  },
  deadline: '2024-06-10',
  commentsCount: 5,
  createdAt: '2024-05-28'
}, {
  id: '6',
  title: 'Onboard new creator Emma Wilson',
  description: 'Complete onboarding process and setup initial campaign brief',
  status: 'in_progress',
  priority: 'medium',
  assignee: {
    id: '5',
    name: 'Emma Wilson',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800'
  },
  deadline: '2024-06-18',
  commentsCount: 0,
  createdAt: '2024-06-06'
}];
export function TasksPage() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(mockTasks);
  const [statusFilter, setStatusFilter] = useState<'all' | TaskStatus>('all');
  const [priorityFilter, setPriorityFilter] = useState<'all' | 'low' | 'medium' | 'high'>('all');
  const filteredTasks = tasks.filter(task => {
    const matchesStatus = statusFilter === 'all' || task.status === statusFilter;
    const matchesPriority = priorityFilter === 'all' || task.priority === priorityFilter;
    return matchesStatus && matchesPriority;
  });
  const stats = {
    total: tasks.length,
    todo: tasks.filter(t => t.status === 'todo').length,
    inProgress: tasks.filter(t => t.status === 'in_progress').length,
    done: tasks.filter(t => t.status === 'done').length
  };
  const handleStatusChange = (taskId: string, newStatus: TaskStatus) => {
    setTasks(prev => prev.map(t => t.id === taskId ? {
      ...t,
      status: newStatus
    } : t));
  };
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-1514">
      <header className="bg-white border-b sticky top-0 z-10" data-id="element-1515">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-1516">
          <div className="flex items-center" data-id="element-1517">
            <Button variant="ghost" size="sm" className="mr-4" onClick={() => navigate('/manager')} data-id="element-1518">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-1519" /> Back
            </Button>
            <h1 className="text-xl font-bold text-gray-900" data-id="element-1520">Tasks</h1>
          </div>
          <Button variant="primary" size="sm" className="bg-blue-600 hover:bg-blue-700" data-id="element-1521">
            <Plus className="h-4 w-4 mr-2" data-id="element-1522" /> Create Task
          </Button>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1523">
          <div className="flex space-x-8 -mb-px" data-id="element-1524">
            <button onClick={() => navigate('/manager')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1525">
              Overview
            </button>
            <button onClick={() => navigate('/manager/brands')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1526">
              Brands
            </button>
            <button onClick={() => navigate('/manager/projects')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1527">
              Projects
            </button>
            <button className="pb-4 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-1528">
              Tasks
            </button>
            <button onClick={() => navigate('/manager/platforms')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1529">
              Platforms
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1530">
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-1531">
          <Card data-id="element-1532">
            <CardContent className="p-6" data-id="element-1533">
              <div className="flex items-center justify-between" data-id="element-1534">
                <div data-id="element-1535">
                  <p className="text-sm text-gray-500" data-id="element-1536">Total Tasks</p>
                  <p className="text-2xl font-bold text-gray-900" data-id="element-1537">
                    {stats.total}
                  </p>
                </div>
                <div className="h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-1538">
                  <ListTodo className="h-6 w-6 text-blue-600" data-id="element-1539" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-1540">
            <CardContent className="p-6" data-id="element-1541">
              <div className="flex items-center justify-between" data-id="element-1542">
                <div data-id="element-1543">
                  <p className="text-sm text-gray-500" data-id="element-1544">To Do</p>
                  <p className="text-2xl font-bold text-gray-600" data-id="element-1545">
                    {stats.todo}
                  </p>
                </div>
                <div className="h-12 w-12 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-1546">
                  <ListTodo className="h-6 w-6 text-gray-600" data-id="element-1547" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-1548">
            <CardContent className="p-6" data-id="element-1549">
              <div className="flex items-center justify-between" data-id="element-1550">
                <div data-id="element-1551">
                  <p className="text-sm text-gray-500" data-id="element-1552">In Progress</p>
                  <p className="text-2xl font-bold text-blue-600" data-id="element-1553">
                    {stats.inProgress}
                  </p>
                </div>
                <div className="h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-1554">
                  <Clock className="h-6 w-6 text-blue-600" data-id="element-1555" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-1556">
            <CardContent className="p-6" data-id="element-1557">
              <div className="flex items-center justify-between" data-id="element-1558">
                <div data-id="element-1559">
                  <p className="text-sm text-gray-500" data-id="element-1560">Done</p>
                  <p className="text-2xl font-bold text-green-600" data-id="element-1561">
                    {stats.done}
                  </p>
                </div>
                <div className="h-12 w-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-1562">
                  <CheckCircle2 className="h-6 w-6 text-green-600" data-id="element-1563" />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Filters */}
        <div className="flex items-center justify-between mb-6" data-id="element-1564">
          <div className="flex items-center space-x-2" data-id="element-1565">
            <span className="text-sm text-gray-500 mr-2" data-id="element-1566">Status:</span>
            <Button variant={statusFilter === 'all' ? 'secondary' : 'ghost'} size="sm" onClick={() => setStatusFilter('all')} data-id="element-1567">
              All
            </Button>
            <Button variant={statusFilter === 'todo' ? 'secondary' : 'ghost'} size="sm" onClick={() => setStatusFilter('todo')} data-id="element-1568">
              To Do
            </Button>
            <Button variant={statusFilter === 'in_progress' ? 'secondary' : 'ghost'} size="sm" onClick={() => setStatusFilter('in_progress')} data-id="element-1569">
              In Progress
            </Button>
            <Button variant={statusFilter === 'done' ? 'secondary' : 'ghost'} size="sm" onClick={() => setStatusFilter('done')} data-id="element-1570">
              Done
            </Button>
          </div>
          <div className="flex items-center space-x-2" data-id="element-1571">
            <span className="text-sm text-gray-500 mr-2" data-id="element-1572">Priority:</span>
            <Button variant={priorityFilter === 'all' ? 'secondary' : 'ghost'} size="sm" onClick={() => setPriorityFilter('all')} data-id="element-1573">
              All
            </Button>
            <Button variant={priorityFilter === 'low' ? 'secondary' : 'ghost'} size="sm" onClick={() => setPriorityFilter('low')} data-id="element-1574">
              Low
            </Button>
            <Button variant={priorityFilter === 'medium' ? 'secondary' : 'ghost'} size="sm" onClick={() => setPriorityFilter('medium')} data-id="element-1575">
              Medium
            </Button>
            <Button variant={priorityFilter === 'high' ? 'secondary' : 'ghost'} size="sm" onClick={() => setPriorityFilter('high')} data-id="element-1576">
              High
            </Button>
          </div>
        </div>

        {/* Tasks Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1577">
          {filteredTasks.map(task => <TaskCard key={task.id} task={task} onStatusChange={handleStatusChange} data-id="element-1578" />)}
        </div>

        {filteredTasks.length === 0 && <Card data-id="element-1579">
            <CardContent className="p-12 text-center" data-id="element-1580">
              <ListTodo className="h-12 w-12 text-gray-400 mx-auto mb-4" data-id="element-1581" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1582">
                No tasks found
              </h3>
              <p className="text-gray-500 mb-6" data-id="element-1583">
                Try adjusting your filters or create a new task.
              </p>
              <Button variant="primary" className="bg-blue-600 hover:bg-blue-700" data-id="element-1584">
                <Plus className="h-4 w-4 mr-2" data-id="element-1585" /> Create Task
              </Button>
            </CardContent>
          </Card>}
      </main>
    </div>;
}